import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsTeamsFieldConfig } from '../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class TeamsCallQueueTeamsResource {
  private _httpClient = inject(HttpClient);

  get(tenantId: string): Observable<MicrosoftTeamsTeamsFieldConfig> {
    return this._httpClient.get<MicrosoftTeamsTeamsFieldConfig>(
      `/services/microsoft/call-queue-management/tenants/${tenantId}/teams`,
    );
  }
}
